import { useNavigate } from 'react-router-dom';
import QR from '../assets/img/scanner.png';
import { useEffect } from 'react';
import { BgCanvas } from '../components/canvas';
import { Container } from '@mui/system';
import { Box } from '@mui/material';
import Grid from '@mui/material/Grid';

// import styles from "../style/pages/home.module";
import Paper from '@mui/material/Paper'; // Example component for visual separation
import { styled } from '@mui/material/styles'; // For styling the Paper component
// import

function Home() {

    // useEffect(()=>{
    //     BgCanvas()
    // },0)

    const navigate = useNavigate();

    const userRegisterBtn = () => {
       navigate('/students-registration');
    }
    const adminLoginBtn = () => {
        navigate('/admin-login');
     }
     const userLoginBtn = () => {
        navigate('/students-login');
     }
      
    return(
       <>
        <div className='canvas-element' id='canvas-element'>
</div>

<Container maxWidth="lg" className="home">
<Box sx={{ flexGrow: 1 }}>
      <Grid container spacing={2} className='parentdiv'>
        <Grid item xs={12} md={12} className=''>
            {/* <h1 className='mt-20 mb-20 heading'>Empowering Students Through Guided Learning</h1> */}
            <h1 className='mt-20 mb-20 heading'>Guided Learning for Young Minds</h1>

            <div sx={{}} style={{flexDirection:"column"} }
                className="parabg  sectors__item relative flex justify-center items-center rounded-25 overflow-hidden border-1 border-white/40"
              >
                <img
                  className="absolute object-cover size-full"
                  src="/texture-33.webp"
                  alt="Texture"
                  width=""
                  height=""
                  loading="lazy"
                />
                <div
                  className="sectors__item__inner mb-16"
                  data-animation="opa"
                  
                >
                 
                  {/* <p
                    className="text-pretty --is-visible"
                   
                  > */}
                    <div>
                    <p>Welcome to Success Tutorial, where we nurture young minds from 1st to 9th grade with expert guidance and personalized learning. Our experienced teacher, {/* <span className='highlight'> Kavita Dhadave (MSc, BEd, Physics)</span>, */}ensures a strong foundation in academics while fostering a love for learning.</p>
            <p>Join our tuition program and experience structured lessons, interactive teaching methods, and regular assessments to track progress. Let’s shape a brighter future together!</p>
                      </div>
                      
                  {/* </p> */}
                 
                </div>
                <div
                  className="sectors__item__inner"
                  data-animation="opa"
                  
                >
                 
                  <div
                    className="text-pretty --is-visible"
                   
                  >
                    <h3
                    className="h2 text-balance --is-visible highlight"
                    data-animation="subtitle"                   
                  >
                    <span>Student Registration</span>
                  </h3>
                  </div>
                    {/* <div> */}
                    <p> Start your learning journey with expert guidance. Register now to secure your seat and gain access to quality education.</p>
                    <div style={{display:"flex"}}>
                    <a
                    //  href="javascript:void(0)"
                    className="button button--white --is-visible"
                    data-animation="fade-up"
                    target=""
                    onClick={userRegisterBtn}
                  >
                    <span className='text-pretty --is-visible'>Register Now</span>
                    <div>
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M15.7071 8.70711C16.0976 8.31658 16.0976 7.68342 15.7071 7.29289L9.34315 0.928932C8.95262 0.538408 8.31946 0.538408 7.92893 0.928932C7.53841 1.31946 7.53841 1.95262 7.92893 2.34315L13.5858 8L7.92893 13.6569C7.53841 14.0474 7.53841 14.6805 7.92893 15.0711C8.31946 15.4616 8.95262 15.4616 9.34315 15.0711L15.7071 8.70711ZM0 9H15V7H0V9Z"
                          fill="white"
                        ></path>
                        <path
                          d="M15.7071 8.70711C16.0976 8.31658 16.0976 7.68342 15.7071 7.29289L9.34315 0.928932C8.95262 0.538408 8.31946 0.538408 7.92893 0.928932C7.53841 1.31946 7.53841 1.95262 7.92893 2.34315L13.5858 8L7.92893 13.6569C7.53841 14.0474 7.53841 14.6805 7.92893 15.0711C8.31946 15.4616 8.95262 15.4616 9.34315 15.0711L15.7071 8.70711ZM0 9H15V7H0V9Z"
                          fill="white"
                        ></path>
                      </svg>
                    </div>
                  </a>
                  </div>
                      {/* </div> */}
                      
                  {/* </p> */}
                 
                </div>
               
              </div>
       
            
        </Grid>
        <Grid  item xs={12} md={6} >
          <div className=" sectors__grid mt-20 mb-20 s:mt-56 --layout-grid">
              <div
                className="sectors__item relative flex justify-center items-center rounded-25 overflow-hidden border-1 border-white/40"
              >
                <img
                  className="absolute object-cover size-full"
                  src="/texture-11.webp"
                  alt="Texture"
                  width=""
                  height=""
                  loading="lazy"
                />
                <div
                  className="sectors__item__inner --is-visible"
                  data-animation="opa">
                  <h3
                    className="h2 text-balance --is-visible highlight"
                    data-animation="subtitle"                   
                  >
                    <span>Already Registered? Log In to Your Account</span>
                  </h3>
                  {/* <p
                    className="text-pretty --is-visible"
                    data-animation="paragraph"> */}
                    <div className="text-pretty --is-visible"
                    data-animation="paragraph"> 
                    Access your student dashboard, track progress, and stay updated with your study schedule. Log in now to continue your learning journey.
                      </div>
                      
                  {/* </p> */}
                  <a
                    //  href="javascript:void(0)"
                    className="button button--white mt-24 --is-visible"
                    data-animation="fade-up"
                    target=""
                    onClick={userLoginBtn}
                  >
                    <span>Student Login</span>
                    <div>
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M15.7071 8.70711C16.0976 8.31658 16.0976 7.68342 15.7071 7.29289L9.34315 0.928932C8.95262 0.538408 8.31946 0.538408 7.92893 0.928932C7.53841 1.31946 7.53841 1.95262 7.92893 2.34315L13.5858 8L7.92893 13.6569C7.53841 14.0474 7.53841 14.6805 7.92893 15.0711C8.31946 15.4616 8.95262 15.4616 9.34315 15.0711L15.7071 8.70711ZM0 9H15V7H0V9Z"
                          fill="white"
                        ></path>
                        <path
                          d="M15.7071 8.70711C16.0976 8.31658 16.0976 7.68342 15.7071 7.29289L9.34315 0.928932C8.95262 0.538408 8.31946 0.538408 7.92893 0.928932C7.53841 1.31946 7.53841 1.95262 7.92893 2.34315L13.5858 8L7.92893 13.6569C7.53841 14.0474 7.53841 14.6805 7.92893 15.0711C8.31946 15.4616 8.95262 15.4616 9.34315 15.0711L15.7071 8.70711ZM0 9H15V7H0V9Z"
                          fill="white"
                        ></path>
                      </svg>
                    </div>
                  </a>
                </div>
              </div>
          </div>
        </Grid>
        <Grid  item xs={12} md={6} className=''>
        {/* <Item> */}
        <div className="parentdiv sectors__grid mt-20 mb-20 s:mt-56 --layout-grid">
              
              <div
                className="sectors__item relative flex justify-center items-center rounded-25 overflow-hidden border-1 border-white/40"
              >
                <img
                  className="absolute object-cover size-full"
                  src="/texture-22.webp"
                  alt="Texture"
                  width=""
                  height=""
                  loading="lazy"
                />
                <div
                  className="sectors__item__inner --is-visible"
                  data-animation="opa">
                  <h3
                    className="h2 text-balance --is-visible highlight"
                    data-animation="subtitle">
                    <div>
                   Admin Access for Managing Students
                      </div>
                  </h3>
                  {/* <p
                    className="text-pretty --is-visible"
                    data-animation="paragraph"
                   
                  > */}
                    <div className="text-pretty --is-visible"
                    data-animation="paragraph">
                    Admins can view, manage, and update registered student details. 
                    Ensure seamless student management with a dedicated dashboard.
                      </div>
                    
                      
                  {/* </p> */}
                  <a
                    // href="javascript:void(0)"
                    className="button button--white mt-24 --is-visible"
                    data-animation="fade-up"
                    target=""
                    onClick={adminLoginBtn}
                  >
                    <span>Admin Login</span>
                    <div>
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M15.7071 8.70711C16.0976 8.31658 16.0976 7.68342 15.7071 7.29289L9.34315 0.928932C8.95262 0.538408 8.31946 0.538408 7.92893 0.928932C7.53841 1.31946 7.53841 1.95262 7.92893 2.34315L13.5858 8L7.92893 13.6569C7.53841 14.0474 7.53841 14.6805 7.92893 15.0711C8.31946 15.4616 8.95262 15.4616 9.34315 15.0711L15.7071 8.70711ZM0 9H15V7H0V9Z"
                          fill="white"
                        ></path>
                        <path
                          d="M15.7071 8.70711C16.0976 8.31658 16.0976 7.68342 15.7071 7.29289L9.34315 0.928932C8.95262 0.538408 8.31946 0.538408 7.92893 0.928932C7.53841 1.31946 7.53841 1.95262 7.92893 2.34315L13.5858 8L7.92893 13.6569C7.53841 14.0474 7.53841 14.6805 7.92893 15.0711C8.31946 15.4616 8.95262 15.4616 9.34315 15.0711L15.7071 8.70711ZM0 9H15V7H0V9Z"
                          fill="white"
                        ></path>
                      </svg>
                    </div>
                  </a>
                </div>
              </div>
            
            </div>
            {/* </Item> */}
        </Grid>
       
       
        
        
      </Grid>
      <div className="location-section" style={{display:"none"}}>
  Best tuition classes in Tapovan Amaravati | tuition classes in Tapowan Amaravati | Success Tutorials Amaravati |
  Top tutorial center in Tapovan | Quality tuition for 1st to 9th grade in Amaravati
</div> 
    </Box>
{/* 
    <Box sx={{ flexGrow: 1 }}>
      <Grid container spacing={2}>
        <Grid item md={12} xs={12} className='adminlgnbx' sx={{marginBottom:"80px"}}>
        <div
                className="parentdiv mt-40 sectors__item relative flex justify-center items-center rounded-25 overflow-hidden border-1 border-white/40"
              >
                <img
                  className="absolute object-cover size-full"
                  src="/texture-33.webp"
                  alt="Texture"
                  width=""
                  height=""
                  loading="lazy"
                />
                <div
                  className="sectors__item__inner"
                  data-animation="opa"
                  
                >
                  <h3
                    className="h2 text-balance highlight"
                    data-animation="subtitle">
                    Admin Access for Managing Students
                  </h3>
                  <p
                    className="text-pretty --is-visible"
                    data-animation="paragraph"
                   
                  >
                    <div>
                    Admins can view, manage, and update registered student details. 
                      </div>
                      <div>
                      Ensure seamless student management with a dedicated dashboard.
                      </div>
                  </p>
                  <a
                    href="javascript:void(0)"
                    className="button button--white mt-24 --is-visible"
                    data-animation="fade-up"
                    target=""
                    onClick={adminLoginBtn}
                  >
                    <span>Admin Login</span>
                    <div>
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M15.7071 8.70711C16.0976 8.31658 16.0976 7.68342 15.7071 7.29289L9.34315 0.928932C8.95262 0.538408 8.31946 0.538408 7.92893 0.928932C7.53841 1.31946 7.53841 1.95262 7.92893 2.34315L13.5858 8L7.92893 13.6569C7.53841 14.0474 7.53841 14.6805 7.92893 15.0711C8.31946 15.4616 8.95262 15.4616 9.34315 15.0711L15.7071 8.70711ZM0 9H15V7H0V9Z"
                          fill="white"
                        ></path>
                        <path
                          d="M15.7071 8.70711C16.0976 8.31658 16.0976 7.68342 15.7071 7.29289L9.34315 0.928932C8.95262 0.538408 8.31946 0.538408 7.92893 0.928932C7.53841 1.31946 7.53841 1.95262 7.92893 2.34315L13.5858 8L7.92893 13.6569C7.53841 14.0474 7.53841 14.6805 7.92893 15.0711C8.31946 15.4616 8.95262 15.4616 9.34315 15.0711L15.7071 8.70711ZM0 9H15V7H0V9Z"
                          fill="white"
                        ></path>
                      </svg>
                    </div>
                  </a>
                </div>
              </div>
       
        </Grid>
       
        
        
      </Grid>
    </Box> */}
</Container>
         
            
            </> 
    )
}

export { Home }
/* 



*/